import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-client';

export interface NotificationPreferenceItem {
  category: string;
  label: string;
  enabled: boolean;
}

export interface UpdateNotificationPreferencePayload {
  category: string;
  enabled: boolean;
}

export function useNotificationPreferences() {
  return useQuery({
    queryKey: queryKeys.notificationPreferences.list(),
    queryFn: async (): Promise<NotificationPreferenceItem[]> => {
      const response = await apiClient.get<NotificationPreferenceItem[]>('/api/v1/notification-preferences/');
      return response.data;
    },
    staleTime: 1000 * 60 * 5,
  });
}

export function useUpdateNotificationPreference() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: UpdateNotificationPreferencePayload): Promise<NotificationPreferenceItem> => {
      const response = await apiClient.post<NotificationPreferenceItem>('/api/v1/notification-preferences/', payload);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.notificationPreferences.all });
    },
  });
}
